// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3ehyr","colMaxWidth":"Table_colMaxWidth__3lNvj"};